/**
 * QrCode — renders a string as an inline SVG QR code. Generation only (no camera).
 * Used to show a hosted share link so an in-person peer can scan instead of us
 * sending the link over a chat app. The value is our own link, so the generated
 * SVG is trusted.
 */
import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export function QrCode(props: { value: string; size?: number }): JSX.Element {
  const [svg, setSvg] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    void QRCode.toString(props.value, {
      type: 'svg',
      margin: 1,
      errorCorrectionLevel: 'M',
      width: props.size ?? 220,
    })
      .then((out) => {
        if (alive) {
          setSvg(out);
          setError(null);
        }
      })
      .catch((e: unknown) => {
        if (alive) setError((e as Error).message);
      });
    return () => {
      alive = false;
    };
  }, [props.value, props.size]);

  if (error) return <p className="hint qr-error">Could not render QR: {error}</p>;
  return (
    <div className="qr-code" role="img" aria-label="QR code" dangerouslySetInnerHTML={{ __html: svg }} />
  );
}
